/* !
 * setting.js v1.0.0
 * Copyright, Connecty Inc.
 */
// console.log = function () {};

(() => {
	const siteName = 'default-package';
	const htmlHasClass = (_class) => { return document.documentElement.classList.contains(_class); };
	const a = 'is-active';
	const v = 'is-visible';
	const f = 'is-fixed';

	FUNCTIONS = {
		va: {
			pathname: location.pathname,
			isMobile: htmlHasClass('ua-mobile'),
			device: {
				desktop: 1024,
				sp: 768
			},
			window: {
				width: window.innerWidth,
				height: window.innerHeight
			},
			header: {
				desktop: 100,
				sp: 75
			}
		},
		localDecision() {
			const regExp = new RegExp(`(test\\.${siteName}\\.connecty\\.co\\.jp|copre\\.jp|localhost|192\\.168\\.|100\\.64\\.)`, 'g');
			return regExp.test(location.hostname);
		},
		localLoading() { // ローカル環境ならincludeをAjaxで読み込む
			const _this = this;
			const key = 'inc_';
			let ajaxArray = [];
			let ajaxArrayList = [];
			let includeClass = document.querySelectorAll(`[class*="${key}"]`);

			includeClass.forEach(ele => {
				let path = ele.innerHTML.split(' ')[1];
				ajaxArray.push(path);
			});

			if (ajaxArray.length) {
				ajaxArray.forEach(ele => {
					let xhr = new XMLHttpRequest();
					let promise = new Promise((resolve, reject) => {
						xhr.onreadystatechange = function () {
							if (xhr.readyState === 4) {
								if (xhr.status === 200) {
									resolve(xhr.responseText);
								} else {
									reject(xhr.statusText);
								}
							}
						};
					});
					xhr.open('GET', ele + '.html', true);
					xhr.send();
					ajaxArrayList.push(promise);
				});

				Promise.all(ajaxArrayList).then(results => {
					let regExp = new RegExp(key);

					results.forEach(ele => {
						let classList = ele.split(/ |\"/g);
						let position;

						classList.forEach(ele2 => {
							if (ele2.match(regExp)) { position = ele2; }
						});
						document.querySelectorAll('.' + position).forEach(ele2 => {
							ele2.outerHTML = ele;
						});
						console.log('Succeeded to read the include file!:', position);
					});

					// 置換完了時にカスタムイベントを発火
					document.dispatchEvent(new Event('localincludeLoaded'));

					_this.loadDelayScript();
				}).catch((error) => {
					console.error('Failed to read the include file:', error);

					document.dispatchEvent(new Event('localincludeLoaded'));
					_this.loadDelayScript();
				});
			} else {
				document.dispatchEvent(new Event('localincludeLoaded'));
				_this.loadDelayScript();
			}
		},
		getQuery() {
			let vars = [];
			let hash = null;
			let hashes = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&');
			hashes.forEach(ele => {
				hash = ele.split('=');
				hash[1] = (hash[1].indexOf('#') !== -1) ? hash[1].split('#')[0] : hash[1];
				vars.push(hash[0]);
				vars[hash[0]] = hash[1];
			});
			return vars;
		},
		accordion() {
			const details = document.querySelectorAll('.js-accordion');

			details.forEach(ele => {
				const summary = ele.querySelector('summary');
				const wrapper = ele.querySelector('.mod-accordion-wrapper');
				const plus = ele.querySelector('.mod-accordion-plus');
				summary.addEventListener('click', e => {
					e.preventDefault();

					if (ele.open) {
						const close = wrapper.animate(
							{
								opacity: [1, 0],
								height: [wrapper.offsetHeight + 'px', 0],
							},
							{
								duration: 300,
								easing: 'ease',
							}
						);

						// 閉じるとき：90deg → 0deg
						plus.animate(
							{
								transform: [
									'translate(-50%, -50%) rotate(90deg)',
									'translate(-50%, -50%) rotate(0deg)'
								],
							},
							{
								duration: 300,
								pseudoElement: "::after",
								easing: 'ease',
								fill: 'forwards',
							}
						);

						close.onfinish = () => {
							ele.removeAttribute('open');
						}
					} else {
						ele.setAttribute('open', 'true');

						wrapper.animate(
							{
								opacity: [0, 1],
								height: [0, wrapper.offsetHeight + 'px'],
							},
							{
								duration: 300,
								easing: 'ease',
							}
						);

						// 開くとき：0deg → 90deg
						plus.animate(
							{
								transform: [
									'translate(-50%, -50%) rotate(0deg)',
									'translate(-50%, -50%) rotate(90deg)'
								],
							},
							{
								duration: 300,
								pseudoElement: "::after",
								easing: 'ease',
								fill: 'forwards',
							}
						);
					}
				});
			});
		},
		tabSwitch() {
			let $tab = document.querySelectorAll('.js-tab');
			let $content = document.querySelectorAll('.js-tab-content');
			if ($tab.length) {
				// ハッシュタグで絞り込み
				if (location.hash) {
					let hash = location.hash.split('#')[1];
					$tab.forEach(ele => {
						ele.classList.remove(a);
						if (ele.getAttribute('data-target').match(hash)) {
							ele.classList.remove(a);
						}
					});
					$content.forEach(ele => {
						ele.classList.remove(a);
						ele.classList.remove(v);
						if (ele.getAttribute('data-target').match(hash)) {
							$(ele).addClass(a);
							setTimeout(() => { ele.classList.add(v); }, 200);
						}
					});
				}

				$tab.forEach(ele => {
					ele.addEventListener('click', () => {
						$tab.forEach(ele2 => { ele2.classList.remove(a); })
						ele.classList.add(a);
						$content.forEach(ele => {
							ele.classList.remove(a);
							ele.classList.remove(v);
						});

						let $target;
						let target = ele.getAttribute('data-target');
						if (target === 'all') {
							$target = $content;
						} else {
							$target = document.querySelectorAll('[data-target="' + target + '"]');
						}
						$target.forEach(ele => {
							ele.classList.add(a);
							setTimeout(() => { ele.classList.add(v); }, 200);
						});
					});
				});
			}
		},
		easeScroll() {
			const scrollToObject = (_self) => {
				let hash = _self.currentTarget.href.split('#')[1];
				let pos = hash === 'pagetop' ? 0 : document.getElementById(hash).getBoundingClientRect().top;
				let offset = hash === 'pagetop' ? 0 : window.scrollY;
				pos += offset;

				if (hash !== 'pagetop') {
					if (FUNCTIONS.va.window.width < FUNCTIONS.va.device.sp) {
						pos = pos - FUNCTIONS.va.header.sp;
					} else {
						pos = pos - FUNCTIONS.va.header.desktop;
					}
				}
				window.scrollTo({ top: pos, behavior: 'smooth' });
			}
			// フォーカス用関数
			const scrollFocus = (_hash) => {
				let hash = _hash;
				if (hash !== 'pagetop') {
					const focusableElementsSelector = 'a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), iframe, object, [tabindex="0"], [contenteditable]';
					const focusableElements = Array.from(
						document.getElementById(hash).querySelectorAll(focusableElementsSelector)
					);
					if (focusableElements.length) {
						focusableElements[0].focus({ preventScroll: true });
					}
				}
			};
			// スクロール完了後に実行する関数
			let scrollResolveTimeout;
			const waitForScrollComplete = (_hash) => {
				return new Promise((resolve) => {
					const scrollTimeout = setTimeout(() => {
						resolve(true);
					}, 100);
					const scrollTimeoutEvent = addEventListener('scroll', function fn(e) {
						clearTimeout(scrollTimeout);
						clearTimeout(scrollResolveTimeout);
						scrollResolveTimeout = setTimeout(function () {
							scrollFocus(_hash);
							removeEventListener('scroll', fn);
							resolve(true);
						}, 100);
					});
				});
			};
			document.querySelectorAll('a[rel="scroll"]').forEach((ele) => {
				ele.addEventListener('click', async (e) => {
					e.preventDefault();
					if (/#/.test(e.currentTarget.href)) {
						scrollToObject(e);
						let hash = e.currentTarget.href.split('#')[1];
						await waitForScrollComplete(hash);
						return false;
					}
				});
			});
		},
		easeScrollHash() {
			const hash = location.hash;
			if (hash) {
				// フォーカス用関数
				const scrollFocus = (_hash) => {
					let hash = _hash;
					if (hash !== 'pagetop') {
						const focusableElementsSelector = 'a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), iframe, object, [tabindex="0"], [contenteditable]';
						const focusableElements = Array.from(
							document.getElementById(hash).querySelectorAll(focusableElementsSelector)
						);
						if (focusableElements.length) {
							focusableElements[0].focus();
						}
					}
				}
				// スクロール完了後に実行する関数
				let scrollResolveTimeout;
				const waitForScrollComplete = (_hash) => {
					return new Promise((resolve) => {
						const scrollTimeout = setTimeout(() => {
							resolve(true);
						}, 100);
						const scrollTimeoutEvent = addEventListener('scroll', function fn(e) {
							clearTimeout(scrollTimeout);
							clearTimeout(scrollResolveTimeout);
							scrollResolveTimeout = setTimeout(function () {
								scrollFocus(_hash);
								removeEventListener('scroll', fn);
								resolve(true);
							}, 100);
						});
					});
				}
				window.addEventListener('load', async () => {
					document.documentElement.style.display = 'none';
					document.body.style.display = 'none';

					setTimeout(() => {
						document.documentElement.style.display = 'block';
						document.body.style.display = 'block';

						let pos = document.getElementById(hash.split('#')[1]).getBoundingClientRect().top;

						if (FUNCTIONS.va.window.width < FUNCTIONS.va.device.sp) {
							pos -= FUNCTIONS.va.header.sp;
						} else {
							pos -= FUNCTIONS.va.header.desktop;
						}
						window.scrollTo({ top: pos, behavior: 'smooth' });
					}, 100);
					await waitForScrollComplete(hash);
				});
			}
		},
		pageTop() {
			let $footer = document.querySelector('.footer');
			let $pagetop = document.querySelector('.footer__pagetop');

			if ($pagetop && $footer) {
				let ticking = false;
				const updatePagetop = () => {
					const scrollY = window.scrollY;
					const footerRect = $footer.getBoundingClientRect();
					const windowHeight = window.innerHeight;

					// 100px以上スクロールしたら表示
					if (scrollY > 100) {
						$pagetop.classList.add(v);
					} else {
						$pagetop.classList.remove(v);
					}

					// footerが画面に入ったら固定位置に切り替え
					if (footerRect.top <= windowHeight) {
						$pagetop.classList.add(f);
					} else {
						$pagetop.classList.remove(f);
					}

					ticking = false;
				};

				window.addEventListener('scroll', () => {
					if (!ticking) {
						requestAnimationFrame(updatePagetop);
						ticking = true;
					}
				}, { passive: true });

				// 初期チェック
				updatePagetop();
			}
		},
		setModal() {
			const createModal = (_appendHTML, _target) => {
				const $container = document.createElement('div');
				$container.className = 'mod-modal-overlay';
				$container.innerHTML = _appendHTML;
				document.body.appendChild($container);

				$container.classList.add(a);
				setTimeout(() => {
					$container.classList.add(v);
					document.querySelectorAll('.mod-modal-closeArea, .mod-modal-closeBtn, .mod-modalContent a').forEach((ele) => {
						ele.addEventListener('click', (e) => {
							$container.classList.remove(v);
							setTimeout(() => {
								$container.classList.remove(a);
								$container.remove();
								_target.focus();
							}, 400);
						});
					});
					window.addEventListener("keydown", function (event) {
						if (document.querySelectorAll('.mod-modal-overlay').length) {
							// タブキーが押された時
							if (event.key === "Tab") {
								event.preventDefault();
								// モーダル要素内のフォーカス可能な要素の一覧を取得
								const focusableElementsSelector = 'a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), iframe, object, [tabindex="0"], [contenteditable]';
								const focusableElements = Array.from(
									document.querySelector('.mod-modal-overlay').querySelectorAll(focusableElementsSelector)
								);
								// 現在のフォーカス位置を取得
								const focusedItemIndex = focusableElements.indexOf(document.activeElement);
								// shiftキーと同時に押されてた場合
								if (event.shiftKey) {
									if (focusedItemIndex === 0) {
										// 現在のフォーカスが最初の要素の場合、最後の要素にフォーカスを移動
										focusableElements[focusableElements.length - 1].focus();
									} else {
										// 現在のフォーカスが最初の要素以外の場合、前の要素にフォーカスを移動
										focusableElements[focusedItemIndex - 1].focus();
									}
								} else {
									if (focusedItemIndex === focusableElements.length - 1) {
										// 現在のフォーカスが最後の要素の場合、最初の要素にフォーカスを移動
										focusableElements[0].focus();
									} else {
										// 現在のフォーカスが最後の要素以外の場合、次の要素にフォーカスを移動
										focusableElements[focusedItemIndex + 1].focus();
									}
								}
							}
							// ESCキーが押された時
							if (event.key === "Escape") {
								event.preventDefault();
								$container.classList.remove(v);
								setTimeout(() => {
									$container.classList.remove(a);
									$container.remove();
									_target.focus();
								}, 400);
							}
						}
					});
				});
			};
			document.querySelectorAll('.mod-modal').forEach((ele) => {
				ele.addEventListener('click', (e) => {
					let targetKey = e.currentTarget.getAttribute('data-target');
					let $content = document.querySelector(`.mod-modalContent[data-target="${targetKey}"]`);
					if ($content) {
						let closeButton = document.createElement('button');
						closeButton.setAttribute('type', 'button');
						closeButton.className = 'mod-modal-closeBtn';
						closeButton.setAttribute('aria-label', 'close');
						closeButton.innerHTML = '<span aria-hidden="true"></span>';

						$content.appendChild(closeButton);

						let closeArea = document.createElement('div');
						closeArea.className = 'mod-modal-closeArea';
						let containerDiv = document.createElement('div');
						containerDiv.appendChild(closeArea);
						containerDiv.appendChild($content.cloneNode(true));

						createModal(containerDiv.innerHTML, e.currentTarget);
					}
					return false;
				});
			});

			// 画像1個だけのモーダル
			document.querySelectorAll('.mod-modalImg').forEach((ele) => {
				ele.addEventListener('click', (e) => {
					let appendHTML = `<div class="mod-modal-closeArea"></div>
						<button type="button" class="mod-modal-closeBtn" aria-label="close"><span aria-hidden="true"></span></button>
						${e.currentTarget.querySelector('img').outerHTML}`;
					createModal(appendHTML, e.currentTarget);
					return false;
				});
			});
		},
		matchHeight() {
			const $elements = document.querySelectorAll('[data-mh]');
			const groups = new Map();

			$elements.forEach(ele => { ele.style.height = 'auto'; }); // 初期化

			$elements.forEach(ele => {
				const attributeName = ele.getAttribute('data-mh');
				if (!groups.has(attributeName)) {
					groups.set(attributeName, []);
				}
				groups.get(attributeName).push(ele);
			});
			groups.forEach(group => {
				const attributeGroups = new Map();
				group.forEach(ele => {
					const attributeName = ele.getAttribute('data-mh');
					const topPosition = ele.getBoundingClientRect().top;
					const key = attributeName + '_' + topPosition;
					if (!attributeGroups.has(key)) {
						attributeGroups.set(key, []);
					}
					attributeGroups.get(key).push(ele);
				});
				attributeGroups.forEach((item) => {
					const maxHeight = Math.max(...item.map(ele => ele.offsetHeight));
					item.forEach((ele2) => {
						ele2.style.height = `${maxHeight}px`;
					});
				});
			});
		},
		inViewAnimation() {
			const target = document.querySelectorAll('.js-fade');
			const options = {
				root: null,
				rootMargin: '-30% 0px',
				threshold: 0
			};
			const callback = (entries, observer) => {
				entries.forEach(entry => {
					if (entry.isIntersecting) {
						entry.target.classList.add(v);
					}
				});
			};
			const observer = new IntersectionObserver(callback, options);

			target.forEach(ele => {
				observer.observe(ele);
			});
		},
		scrollHeader() {
			const header = document.querySelector('.header');
			if (!header) return;
			const cls = 'is-scroll';
			let lastY = window.scrollY;
			let ticking = false;
			const update = () => {
				const currentY = window.scrollY;
				if (currentY <= 0) {
					header.classList.remove(cls);
				} else if (currentY > lastY) { // 下方向
					header.classList.add(cls);
				} else if (currentY < lastY) { // 上方向
					header.classList.remove(cls);
				}
				lastY = currentY;
				ticking = false;
			};
			window.addEventListener('scroll', () => {
				if (!ticking) {
					requestAnimationFrame(update);
					ticking = true;
				}
			}, { passive: true });
		},
		fileSize() {
			const bytesToSize = (bytes) => {
				var sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
				if (bytes === 0) {
					return 'n/a';
				}
				var i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)), 10);
				if (i === 0) {
					return bytes + ' ' + sizes[i];
				}
				return (bytes / Math.pow(1024, i)).toFixed(1) + ' ' + sizes[i];
			}
			if (document.querySelectorAll('.js-fileSize').length) {
				document.querySelectorAll('.js-fileSize').forEach(function (pdfElement) {
					pdfElement.textContent = bytesToSize(pdfElement.textContent);
				});
			}
		},
		removeElmIfEmpty() {
			// ＜ルート設定対応＞要素が空だったら削除
			const $eleList = document.querySelectorAll('.js-checkEmptyElm');
			$eleList.forEach(ele => {
				if (!ele.textContent.length) {
					ele.remove();
				}
			});
		},
		removeBlockIfListEmpty() {
			// ＜ルート設定対応＞該当のリストにルート設定出力が0件の場合、指定する親ブロックごと削除する
			const $eleList = document.querySelectorAll('.js-checkEmptyList');
			if ($eleList) {
				$eleList.forEach(ele => {
					if (!ele.getElementsByTagName('li').length) {
						ele.closest('.js-checkEmptyList-wrap').remove();
					}
				});
			}
		},
		URLcurrent() {
			if (document.querySelector('.js-current')) {
				document.querySelectorAll('.js-current').forEach(item1 => {
					// 各要素の href を取得し、現在のページのURLに基づいた絶対パスに変換
					const linkPath = new URL(item1.getAttribute('href'), location.origin).pathname.replace(/index\.html$/, '');
					const currentPath = location.pathname.replace(/index\.html$/, '');
					// 現在のページのパスがリンクのパスで始まる場合、is-activeを追加
					if (currentPath == linkPath) {
						item1.classList.add(a);
					}
				});
			}
		},
		pcHeaderMegamenu() {
			if (document.querySelectorAll('.js-header-nav-mega').length) {
				const $header = document.querySelector('.header');
				const $megabtn = document.querySelectorAll('.js-header-nav-mega-btn');
				const $megamenu = document.querySelectorAll('.js-header-nav-mega-contents');
				const closeAllMegaMenus = () => {
					$header.classList.remove(a);
					$megabtn.forEach(btn => {
						btn.classList.remove(a);
						if (btn.nextElementSibling) {
							btn.nextElementSibling.classList.remove(a);
						}
					});
				};
				// メガメニューボタンのクリックイベント処理
				// $megabtn.forEach(btn => {
				// 	btn.addEventListener('click', (e) => {
				// 		const clickedBtn = e.currentTarget;
				// 		const clickedNav = clickedBtn.nextElementSibling; // 対応する .header-nav-pc
				// 		// 他のメガメニューを閉じる
				// 		$megabtn.forEach(otherBtn => {
				// 			if (otherBtn !== clickedBtn) {
				// 				otherBtn.classList.remove(a);
				// 				if (otherBtn.nextElementSibling) {
				// 					otherBtn.nextElementSibling.classList.remove(a);
				// 				}
				// 			}
				// 		});
				// 		// クリックされたメガメニューの開閉
				// 		if (clickedBtn.classList.contains(a)) {
				// 			$header.classList.remove(a);
				// 			clickedBtn.classList.remove(a);
				// 			// clickedNavが存在することを確認してから操作
				// 			if (clickedNav) {
				// 				clickedNav.classList.remove(a);
				// 			}
				// 		} else {
				// 			$header.classList.add(a);
				// 			clickedBtn.classList.add(a);
				// 			if (clickedNav) {
				// 				clickedNav.classList.add(a);
				// 			}
				// 		}
				// 	});
				// });
				// メガメニュー外のクリックで閉じる
				document.addEventListener("click", (event) => {
					const target = event.target;
					const isClickInsideNav = [...$megamenu]
						.some(el => el.contains(target));
					const isClickOnButton = [...$megabtn]
						.some(btn => btn.contains(target));

					if (!isClickInsideNav && !isClickOnButton && $header.classList.contains(a)) {
						closeAllMegaMenus();
					}
				});
				// フォーカスが外れた時のメニュー制御を追加
				$megabtn.forEach(btn => {
					const menu = btn.nextElementSibling;
					if (menu) {
						// フォーカスが .header-nav-pc 内にあるかチェックする関数
						const isInsideAnyHeaderNav = (element) => {
							return Array.from($megamenu).some(headerNav => headerNav.contains(element));
						};
						// フォーカスが外れた時にメニューを閉じる
						menu.addEventListener('focusout', () => {
							setTimeout(() => {
								const focusedElement = document.activeElement;
								const isInsideNav = menu.contains(focusedElement);
								const isInsideButton = btn.contains(focusedElement);
								const isInsideHeaderNav = isInsideAnyHeaderNav(focusedElement);
								// .header-nav-pc 内にフォーカスがない場合に閉じる
								if (!isInsideNav && !isInsideButton && !isInsideHeaderNav) {
									closeAllMegaMenus();
								}
							}, 0);
						});
						// TabキーまたはShift+Tabで移動した際にメニューを閉じる
						document.addEventListener('keydown', (e) => {
							if (e.key === 'Tab') {
								setTimeout(() => {
									const focusedElement = document.activeElement;
									const isInsideNav = menu.contains(focusedElement);
									const isInsideButton = btn.contains(focusedElement);
									const isInsideHeaderNav = isInsideAnyHeaderNav(focusedElement);
									// .header-nav-pc 内にフォーカスがない場合に閉じる
									if (!isInsideNav && !isInsideButton && !isInsideHeaderNav) {
										closeAllMegaMenus();
									}
								}, 0);
							}
						});
					}
				});
				// ESCキーでメガメニューを閉じる
				window.addEventListener("keydown", function (event) {
					if ($header.classList.contains(a)) {
						if (event.key === "Escape") {
							event.preventDefault();
							closeAllMegaMenus();
						}
					}
				});
			}
		},
		spHeaderHamburger() {
			if (document.querySelectorAll('.js-header-hamburger').length) {
				const $header = document.querySelector('.header');
				const $hamburger = document.querySelector('.js-header-hamburger');
				const $nav = document.querySelector('.js-header-nav-sp');
				const $container = document.querySelector('.container');
				let scrollTopNow;
				const fixedOnContainer = () => {
					if (!$container) return;
					scrollTopNow = window.scrollY;
					$container.style.position = 'fixed';
					$container.style.width = '100%';
					$container.style.top = -1 * scrollTopNow;
					$container.style.left = 0;
					const $contents = $container.querySelector('.contents');
					if ($contents) {
						$contents.style.opacity = '0';
					}
				};
				const fixedOffContainer = () => {
					if (!$container) return;
					$container.style.position = 'static';
					const $contents = $container.querySelector('.contents');
					if ($contents) {
						$contents.style.opacity = '1';
					}
					window.scrollTo({ top: scrollTopNow });
				};
				$hamburger.addEventListener('click', (e) => {
					if ($nav.classList.contains(a)) {
						$nav.classList.remove(a);
						$hamburger.classList.remove(a);
						$hamburger.ariaLabel = 'open'
						fixedOffContainer();
					} else {
						fixedOnContainer();
						$nav.classList.add(a);
						$hamburger.classList.add(a);
						$hamburger.ariaLabel = 'close'
					}
				});
				window.addEventListener("keydown", function (event) {
					if ($nav.classList.contains(a)) {
						// タブキーが押された時
						if (event.key === "Tab") {
							event.preventDefault();
							// ヘッダー内のフォーカス可能な要素を取得（display: none の要素を除外）
							const focusableElementsSelector = 'a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), iframe, object, [tabindex="0"], [contenteditable]';
							let focusableElements = Array.from($header.querySelectorAll(focusableElementsSelector))
								.filter(el => el.offsetParent !== null); // 非表示要素を除外
							if (focusableElements.length === 0) return;
							// 現在のフォーカス位置を取得
							const focusedItemIndex = focusableElements.indexOf(document.activeElement);
							console.log(focusedItemIndex, focusableElements);
							// shiftキーと同時に押されてた場合
							if (event.shiftKey) {
								if (focusedItemIndex === 0) {
									// 現在のフォーカスが最初の要素の場合、最後の要素にフォーカスを移動
									focusableElements[focusableElements.length - 1].focus();
								} else {
									// 現在のフォーカスが最初の要素以外の場合、前の要素にフォーカスを移動
									focusableElements[focusedItemIndex - 1].focus();
								}
							} else {
								if (focusedItemIndex === focusableElements.length - 1) {
									// 現在のフォーカスが最後の要素の場合、最初の要素にフォーカスを移動
									focusableElements[0].focus();
								} else {
									// 現在のフォーカスが最後の要素以外の場合、次の要素にフォーカスを移動
									focusableElements[focusedItemIndex + 1].focus();
								}
							}
						}
						// ESCキーが押された時
						if (event.key === "Escape") {
							event.preventDefault();
							$nav.classList.remove(a);
							$hamburger.classList.remove(a);
							$hamburger.ariaLabel = 'close'
							fixedOffContainer();
							$hamburger.focus({ preventScroll: true });
						}
					}
				});
			}
		},
		checkBoxPopup() {
			// チェックボックス ポップアップ
			const popupOpenButtons = document.querySelectorAll(".js-checkPopup-open");
			const popupCloseButtons = document.querySelectorAll(".js-checkPopup-close");

			if (!popupOpenButtons.length) return;

			popupOpenButtons.forEach(function (button) {
				button.addEventListener("click", function () {
					const popup = this.nextElementSibling;
					popup.classList.add('is-active');
				});
			});

			popupCloseButtons.forEach(function (button) {
				button.addEventListener("click", function () {
					const popup = this.parentElement;
					popup.classList.remove('is-active');
				});
			});
		},
		headerSearchToggle() {
			// ヘッダー検索切り替え
			const $searchButtons = document.querySelectorAll('.js-header-search-button');

			if (!$searchButtons.length) return;

			$searchButtons.forEach($searchButton => {
				const $searchWrap = $searchButton.querySelector('.js-header-search-wrap');

				if (!$searchWrap) return;

				$searchButton.addEventListener('click', (e) => {
					e.stopPropagation();
					console.log('click');
					$searchButton.classList.toggle(a);
					$searchWrap.classList.toggle(a);
				});

				// 検索ボックス内のクリックでは閉じないようにする
				$searchWrap.addEventListener('click', (e) => {
					e.stopPropagation();
				});
			});

			// 外側をクリックしたら全て閉じる
			document.addEventListener('click', (e) => {
				$searchButtons.forEach($searchButton => {
					const $searchWrap = $searchButton.querySelector('.js-header-search-wrap');
					if ($searchWrap && !$searchButton.contains(e.target)) {
						$searchButton.classList.remove(a);
						$searchWrap.classList.remove(a);
					}
				});
			});
		},
		headerLangToggle() {
			// ヘッダー言語切り替え
			const $langButtons = document.querySelectorAll('.js-header-lang-button');

			if (!$langButtons.length) return;

			$langButtons.forEach($langButton => {
				const $langWrap = $langButton.querySelector('.js-header-lang-wrap');

				if (!$langWrap) return;

				$langButton.addEventListener('click', (e) => {
					e.stopPropagation();
					$langButton.classList.toggle(a);
					$langWrap.classList.toggle(a);
				});
			});

			// 外側をクリックしたら全て閉じる
			document.addEventListener('click', (e) => {
				$langButtons.forEach($langButton => {
					const $langWrap = $langButton.querySelector('.js-header-lang-wrap');
					if ($langWrap && !$langButton.contains(e.target)) {
						$langButton.classList.remove(a);
						$langWrap.classList.remove(a);
					}
				});
			});
		},
		orienttopHeaderHamburger() {
			// orient-top ページのヘッダー ハンバーガーメニュー
			const $orienttopHamburger = document.querySelector('.js-orienttop-header-hamburger');

			if (!$orienttopHamburger) return;

			const $hamburgerWrap = $orienttopHamburger.querySelector('.js-header-hamburger-wrap');

			if (!$hamburgerWrap) return;

			$orienttopHamburger.addEventListener('click', (e) => {
				e.stopPropagation();
				$orienttopHamburger.classList.toggle(a);
				$hamburgerWrap.classList.toggle(a);
			});

			// 外側をクリックしたら閉じる
			document.addEventListener('click', (e) => {
				if ($hamburgerWrap && !$orienttopHamburger.contains(e.target)) {
					$orienttopHamburger.classList.remove(a);
					$hamburgerWrap.classList.remove(a);
				}
			});

			// ESCキーで閉じる
			document.addEventListener('keydown', (e) => {
				if (e.key === 'Escape' && $hamburgerWrap.classList.contains(a)) {
					$orienttopHamburger.classList.remove(a);
					$hamburgerWrap.classList.remove(a);
				}
			});
		},
		scrollHint() {
			// .js-scrollableがある場合のScrollHint処理
			const scrollableElements = document.querySelectorAll('.js-scrollable');
			if (scrollableElements.length > 0) {
				// ScrollHintライブラリが存在するかチェック
				if (typeof ScrollHint === 'undefined') {
					// CSSファイルを動的に追加
					const cssLink = document.createElement('link');
					cssLink.rel = 'stylesheet';
					cssLink.href = 'https://unpkg.com/scroll-hint@latest/css/scroll-hint.css';
					document.head.appendChild(cssLink);

					// JSファイルを動的に追加
					const script = document.createElement('script');
					script.src = 'https://unpkg.com/scroll-hint@latest/js/scroll-hint.min.js';
					script.onload = () => {
						this.initScrollHint();
					};
					document.head.appendChild(script);
				} else {
					this.initScrollHint();
				}
			}
		},
		initScrollHint() {
			// URLが/en/配下かチェック
			const isEnglishPage = location.pathname.includes('/en/');
			const scrollableText = isEnglishPage ? 'scrollable' : 'スクロールできます';

			new ScrollHint('.js-scrollable', {
				i18n: {
					scrollable: scrollableText
				}
			});
		},
		taxIncludedPrice() {
			const priceElements = document.querySelectorAll('.js-price-inc-tax');
			console.log('税抜き価格表示処理開始', priceElements);
			priceElements.forEach((element) => {
				let priceContainer = element.closest('.__price');
				let priceText = '';

				if (priceContainer) {
					// 既存の処理: priceContainerを使った処理
					const smallElement = priceContainer.querySelector('.__small>span');
					if (smallElement) {
						priceText = smallElement.textContent;
					} else {
						// フォールバック: .__small>spanが見つからない場合は.__price直接から取得
						priceText = priceContainer.textContent;
					}
				} else {
					// フォールバック: closestで見つからない場合は兄弟要素や親要素内を探す
					const parentElement = element.parentElement;
					if (parentElement) {
						priceContainer = parentElement.querySelector('.__price');
						if (priceContainer) {
							const smallElement = priceContainer.querySelector('.__small>span');
							if (smallElement) {
								priceText = smallElement.textContent;
							} else {
								priceText = priceContainer.textContent;
							}
						}
					}
				}

				if (priceText) {
					const priceMatch = priceText.match(/¥?([\d,]+)/);
					if (priceMatch) {
						const taxExcludedPrice = parseInt(priceMatch[1].replace(/,/g, ''));
						const taxIncludedPrice = Math.floor(taxExcludedPrice * 1.1);
						const formattedPrice = taxIncludedPrice.toLocaleString();
						element.textContent = `¥${formattedPrice}`;
						element.classList.add('is-visible');
					}
				}
			});
		},
		tabInit() {
			const tabWrapper = document.querySelector('[data-tab="wrapper"]');

			if (!tabWrapper) return;

			const tabButtons = tabWrapper.querySelectorAll('[data-tab="button"]');
			const tabBg = tabWrapper.querySelector('[data-tab="bg"]');
			const tabList = tabWrapper.querySelector('[data-tab="list"]');

			// ニュースページ専用の処理
			const currentPath = location.pathname;
			if (currentPath.match(/\/(ja|en)\/news\//)) {
				// 全てのaria-selectedをfalseに設定
				tabButtons.forEach(button => {
					button.setAttribute('aria-selected', 'false');
					button.setAttribute('tabindex', '-1');
				});

				// URLに基づいて適切なタブをアクティブにする
				tabButtons.forEach(button => {
					const spanText = button.querySelector('span')?.textContent?.trim();

					if (((spanText === 'ニュースリリース' || spanText === 'News Release') && currentPath.includes('/news/newsrelease/')) ||
						((spanText === 'プレスリリース' || spanText === 'Press Release') && currentPath.includes('/news/press/')) ||
						((spanText === 'サポート' || spanText === 'Support') && currentPath.includes('/news/support/')) ||
						((spanText === 'All') && (currentPath.match(/\/(ja|en)\/news\/$/) || currentPath.match(/\/(ja|en)\/news\/index\.html$/)))) {

						button.setAttribute('aria-selected', 'true');
						button.setAttribute('tabindex', '0');
					}
				});
			}

			function updateTabBackground(targetButton = null) {
				// ターゲットが指定されていない場合は現在アクティブなボタンを使用
				const activeButton = targetButton || tabWrapper.querySelector('[aria-selected="true"]');

				if (activeButton && tabList && tabBg) {
					// activeButtonの親li要素を取得
					const buttonLi = activeButton.parentElement;

					// 必要な要素が存在するかチェック
					if (!buttonLi) return;

					// SP環境での計算精度向上のため、少し遅延をつける
					const updateBackground = () => {
						// tabList要素を基準とした相対位置を計算
						const listRect = tabList.getBoundingClientRect();
						const buttonLiRect = buttonLi.getBoundingClientRect();

						// tabBg要素のコンテナ内での位置を計算
						// li要素の位置をul要素内での相対位置として計算
						const x = buttonLiRect.left - listRect.left;
						const y = buttonLiRect.top - listRect.top;

						// 背景のサイズと位置を設定（li要素のサイズを使用）
						// 小数点以下を維持して正確な値を使用
						tabBg.style.width = `${buttonLiRect.width}px`;
						tabBg.style.height = `${buttonLiRect.height}px`;
						tabBg.style.transform = `translate(${x}px, ${y}px)`;

						// デバッグ用
						console.log('Tab position (li-based):', {
							buttonLiLeft: buttonLiRect.left,
							listLeft: listRect.left,
							x,
							y,
							buttonLiWidth: buttonLiRect.width,
							buttonLiHeight: buttonLiRect.height,
							widthRaw: buttonLiRect.width,
							widthRounded: Math.round(buttonLiRect.width)
						});
					};

					// SP環境（768px未満）の場合は少し遅延をつけて計算精度を向上
					if (window.innerWidth < 768) {
						requestAnimationFrame(updateBackground);
					} else {
						updateBackground();
					}
				}
			}

			function updateCurrentClass() {
				// 全ボタンからis-activeクラスを削除
				tabButtons.forEach(button => button.classList.remove('is-active'));

				// 現在アクティブなボタンにis-activeクラスを追加
				const activeButton = tabWrapper.querySelector('[aria-selected="true"]');
				if (activeButton) {
					activeButton.classList.add('is-active');
				}
			}

			function updateCurrentClassWithTarget(targetButton) {
				// 全ボタンからis-activeクラスを削除
				tabButtons.forEach(button => button.classList.remove('is-active'));

				// 指定されたボタンにis-activeクラスを追加
				if (targetButton) {
					targetButton.classList.add('is-active');
				}
			}

			tabButtons.forEach((button) => {
				button.addEventListener("click", (event) => {
					// ニュースページの場合は背景アニメーション後に遷移
					if (currentPath.match(/\/(ja|en)\/news\//)) {
						event.preventDefault(); // デフォルトのリンク遷移を防ぐ

						// 背景アニメーションを実行
						updateTabBackground(button);
						updateCurrentClassWithTarget(button);

						// アニメーション完了後にリンク遷移
						setTimeout(() => {
							const href = button.getAttribute('href');
							if (href) {
								window.location.href = href;
							}
						}, 400); // CSS transitionの時間に合わせて調整
						return;
					}

					// 通常ページでは既存の動作
					// SP環境では少し遅延をつけてから背景を更新
					if (window.innerWidth < 768) {
						// アクティブ状態を先に更新
						tabButtons.forEach(btn => {
							btn.setAttribute('aria-selected', 'false');
							btn.setAttribute('tabindex', '-1');
						});
						button.setAttribute('aria-selected', 'true');
						button.setAttribute('tabindex', '0');

						// 背景の更新は少し遅延
						setTimeout(() => {
							updateTabBackground();
							updateCurrentClass();
						}, 50);
					} else {
						// デスクトップ環境では即座に更新
						tabButtons.forEach(btn => {
							btn.setAttribute('aria-selected', 'false');
							btn.setAttribute('tabindex', '-1');
						});
						button.setAttribute('aria-selected', 'true');
						button.setAttribute('tabindex', '0');

						updateTabBackground();
						updateCurrentClass();
					}
				});

				// ホバー時に背景を移動（ニュースページでも有効）
				button.addEventListener("mouseenter", () => {
					updateTabBackground(button);
					// ホバー時にもis-activeクラスを追加
					updateCurrentClassWithTarget(button);
				});

				// ホバー解除時に元のアクティブボタンの位置に戻す（ニュースページでも有効）
				button.addEventListener("mouseleave", () => {
					updateTabBackground();
					// 元のアクティブボタンにのみis-activeクラスを戻す
					updateCurrentClass();
				});
			});

			// 初期表示時にバックグラウンドを設定
			updateTabBackground();
			// 初期表示時にis-activeクラスを設定
			updateCurrentClass();

			// ウィンドウリサイズ時にバックグラウンドを再計算
			let ticking = false;
			let resizeTimeout = 0;

			const handleResize = () => {
				updateTabBackground();
				ticking = false;
			};

			window.addEventListener("resize", () => {
				// リサイズ中のthrottling処理
				if (!ticking) {
					requestAnimationFrame(handleResize);
					ticking = true;
				}

				// リサイズ完了後のdebounce処理
				clearTimeout(resizeTimeout);
				resizeTimeout = setTimeout(() => {
					updateTabBackground();
				}, 100);
			}, { passive: true });
		},
		marsflag() {
			var el = document.createElement('script');
			if (location.pathname !== '/ja/sitesearch/' && location.pathname !== '/en/sitesearch/') {
				el.src = '//ce.mf.marsflag.com/latest/js/mf-search.js';
			}
			setTimeout(function () {
				document.body.appendChild(el);
			}, 100);
		},
		loadDelayScript() {
			let _this = this;
			_this.accordion();
			_this.tabSwitch();
			_this.easeScroll();
			_this.easeScrollHash();
			_this.pageTop();
			_this.setModal();
			_this.matchHeight();
			_this.inViewAnimation();
			_this.scrollHeader();
			_this.fileSize();
			_this.removeElmIfEmpty();
			_this.removeBlockIfListEmpty();
			_this.URLcurrent();
			_this.pcHeaderMegamenu();
			_this.spHeaderHamburger();
			_this.checkBoxPopup();
			_this.headerSearchToggle();
			_this.headerLangToggle();
			_this.orienttopHeaderHamburger();
			_this.scrollHint();
			_this.tabInit();
			_this.taxIncludedPrice();
			_this.marsflag();

			let resizeTime = 0;
			window.addEventListener('resize', () => {
				clearTimeout(resizeTime);
				resizeTime = setTimeout(() => { _this.matchHeight(); }, 300);
			});
		}
	};

	document.addEventListener('DOMContentLoaded', () => FUNCTIONS.localDecision() ? FUNCTIONS.localLoading() : FUNCTIONS.loadDelayScript());
})();
